'use client'

import { HTMLAttributes } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { Button, Text } from '@/shared/ui'
import Download from '@/public/download.svg'
import style from './symbol-card.module.scss'

export interface SymbolCardProps extends HTMLAttributes<HTMLDivElement> {
  src: string
  alt: string
  locale?: string
  downloadLink: string
  className?: string
}

export const SymbolCard = (props: SymbolCardProps) => {
  const { className, src, alt, downloadLink } = props
  const translate = useTranslations()

  return (
    <li className={clsx(style.container, className)}>
      <div className={style.img}>
        <Image src={src} alt={alt ?? 'alt'} fill style={{ objectFit: 'cover' }} />
      </div>
      <Link className={style.button} href={`/${downloadLink}`} color="white" download target="__blank">
        <Text className={style.label} type="d" tagName="span">
          {translate('download')}
        </Text>
        <Download className={style.download} />
      </Link>
    </li>
  )
}
